import { Component, inject } from '@angular/core';

import { PermissionName } from '@core/api/model';
import { LOCAL_STORAGE_TOKEN } from '@core/domTokens';

const ACADEMY_VISITED_COURSES_KEY = 'academyVisitedCourses';

type Course = {
  key: string;
  permission?: PermissionName;
};

@Component({
  selector: 'app-academy',
  templateUrl: './academy.component.html',
  styleUrls: ['./academy.component.scss'],
  standalone: false,
})
export class AcademyComponent {
  private readonly localStorage = inject<Storage>(LOCAL_STORAGE_TOKEN);

  // key should be the last element of the link, also matching the translation
  public courses: Course[] = [
    {
      key: 'aloora-navigation',
    },
    {
      key: 'aloora-your-labs',
    },
    {
      key: 'aloora-ordering',
      permission: 'ORDERS',
    },
    {
      key: 'aloora-results',
      permission: 'REPORTING',
    },
    {
      key: 'aloora-price-list',
    },
    {
      key: 'aloora-team-management',
    },
    {
      key: 'aloora-alsa',
    },
    {
      key: 'aloora-alsa-connection',
    },
  ];

  public readonly downloadLinks: string[] = [
    'alooraImport',
    'alooraBarcode',
    'alooraEvaluationMacro',
    'alooraWestGuidelinesNetherlands',
    'alooraWestGuidelinesBelgium',
  ];

  protected readonly visitedCourses: Set<string>;

  constructor() {
    this.visitedCourses = new Set<string>(
      JSON.parse(this.localStorage.getItem(ACADEMY_VISITED_COURSES_KEY) || '[]'),
    );
  }

  public courseClicked(courseKey: string) {
    this.visitedCourses.add(courseKey);
    this.localStorage.setItem(
      ACADEMY_VISITED_COURSES_KEY,
      JSON.stringify(Array.from(this.visitedCourses)),
    );
  }
}
